"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var validate_exports = {};
__export(validate_exports, {
  assertLightSensorListener: () => assertLightSensorListener,
  assertUpdateInterval: () => assertUpdateInterval
});
module.exports = __toCommonJS(validate_exports);
function assertLightSensorListener(listener) {
  if (typeof listener !== "function") {
    throw new Error("LightSensor.addListener: listener must be a function");
  }
}
function assertUpdateInterval(intervalMs) {
  if (typeof intervalMs !== "number" || !Number.isFinite(intervalMs) || intervalMs < 0) {
    throw new Error("LightSensor.setUpdateInterval: interval must be a finite number at least 0");
  }
}
//# sourceMappingURL=validate.js.map
